import React from 'react'
import { useParams } from 'react-router-dom'
import MemberDetails from "./MemberDetails"

const MemberDetailsWrapper = (props) => {
    const params = useParams()
    return <MemberDetails {...props} params={params} />
}

export default MemberDetailsWrapper
